import { render, staticRenderFns } from "./social-links.vue?vue&type=template&id=bcaaad72&scoped=true&lang=pug&"
import script from "./social-links.vue?vue&type=script&lang=js&"
export * from "./social-links.vue?vue&type=script&lang=js&"
import style0 from "./social-links.vue?vue&type=style&index=0&id=bcaaad72&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcaaad72",
  null
  
)

export default component.exports